import { render, staticRenderFns } from "./layout-comp.vue?vue&type=template&id=24d1e4f9&scoped=true"
import script from "./layout-comp.vue?vue&type=script&lang=js"
export * from "./layout-comp.vue?vue&type=script&lang=js"
import style0 from "./layout-comp.vue?vue&type=style&index=0&id=24d1e4f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d1e4f9",
  null
  
)

export default component.exports